<div mat-dialog-title>
  <span>{{'badges.modal.assignment.title' | translate}}</span>
</div>
@if (loadingState | async; as state) {
  <div class="badge__ctn">
    <mat-dialog-content>
      @if (state === actionState.READY) {
        <!-- Subscription list -->
        <p class="label">{{'badges.modal.assignment.subscription_list_message' | translate}}</p>
        <ul class="mb-20">
          @for (sub of subList; track sub; let isFirst = $first) {
            <li>
              <input type="radio" class="form-control" [id]="sub.uid" [checked]="isFirst"
                (change)="onChangeSubscription(sub.uid, sub.displayName)">
              <label [htmlFor]="sub.uid">{{sub.displayName}}</label>
            </li>
          }
        </ul>
        <!-- Badge assignment -->
        <form [formGroup]="assigningBadgeForm" (keydown.enter)="$event.preventDefault()">
          <p class="label">{{'badges.modal.assignment.assignment_badge' | translate}}</p>
          <div class="form-group">
            <div class="d-inline-block mr-20">
              <input type="radio" formControlName="selectionMode" id="existingBadge"
                [value]="assigningBadgeType.EXISTING" [checked]="existingBadges">
              <label for="existingBadge">{{'badges.modal.assignment.existing_badge' | translate}}</label>
            </div>
            <div class="d-inline-block">
              <input type="radio" formControlName="selectionMode" id="newBadge"
                [value]="assigningBadgeType.NEW" [checked]="!existingBadges">
              <label for="newBadge">{{'badges.modal.assignment.new_badge' | translate}}</label>
            </div>
          </div>
          @if (selectionModeCtrl.value === assigningBadgeType.EXISTING) {
            <div class="existing-badge__ctn">
              @if (existingBadges) {
                <select class="form-control" formControlName="existingBadgeUid">
                  @for (badge of badgesList.list; track badge) {
                    <option [value]="badge.uid">
                      {{badge.value}}
                      {{badge.provider && badge.provider.length > 0 ? '('+badge.provider+')' : ''}}
                    </option>
                  }
                </select>
              } @else {
                <div class="alert alert-danger">
                  {{'badges.modal.assignment.message.no_existing_badge' | translate}}
                </div>
              }
            </div>
          }
          @if (selectionModeCtrl.value === assigningBadgeType.NEW) {
            <div>
              <div class="new-badge__ctn" formGroupName="newBadge">
                <div class="form-group">
                  <label for="type">{{'badges.modal.assignment.type' | translate}}</label>
                  <select class="form-control" formControlName="badgeType">
                    @for (type of badgeTypes; track type) {
                      <option [value]="type">
                        {{type}}
                      </option>
                    }
                  </select>
                </div>
                <div class="form-group">
                  <label for="type">{{'badges.modal.assignment.value' | translate}}</label>
                  <input class="form-control" type="text" formControlName="badgeValue">
                  @if (submitted && valueCtrl.invalid && (valueCtrl.dirty || valueCtrl.touched)) {
                    <div class="alert alert-danger">
                      {{ valueCtrl.errors.whitespace ? ('error.empty_text' | translate) : '' }}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <div class="text-center mt-20">
            <button class="btn btn--primary" type="submit" [disabled]="noBadgeExistingError"
              (click)="onSubmit()"
            [disabled]="!existingBadges && selectionModeCtrl.value === assigningBadgeType.EXISTING">{{'action.submit' | translate}}</button>
            <button mat-dialog-close
            class="btn btn--outline-grey-color ml-20">{{'action.cancel' | translate}}</button>
          </div>
        </form>
      }
      @if (state === actionState.SUCCESS) {
        <div class="alert alert-success font-size-normal text-center">
          {{'badges.modal.assignment.message.success' | translate : {badge_number : selectedBadgeNumber, subscription_name: selectedSubName} }}
        </div>
        <div class="mt-20 text-center">
          <button class="btn btn--primary"
          [mat-dialog-close]="actionState.SUCCESS">{{'action.close' | translate}}</button>
        </div>
      }
      @if (state === actionState.FAILED) {
        <div class="app-display-errors-message" [error]="error"></div>
        <div class="text-center mt-20">
          <button mat-dialog-close class="btn btn--outline-grey-color">{{'action.cancel' | translate}}</button>
        </div>
      }
      @if (state === actionState.LOADING) {
        <span class="ui-loading" [model]="{isLoading: true}"></span>
      }
    </mat-dialog-content>
  </div>
}